<div class="flex justify-center pt-24 px-4">
  <div class="w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-card px-8 py-8 text-center">
    <ng-container *ngIf="(message | async) as msg; else processing">
      <p class="text-base font-medium text-gray-900 m-0">{{ msg }}</p>
      <a class="button-primary w-full mt-6" href="/">Return to L&amp;R Midland</a>
    </ng-container>
    <ng-template #processing>
      <p class="loading-note justify-center m-0">Signing you in&hellip;</p>
    </ng-template>
  </div>
</div>
